import { render, staticRenderFns } from "./SimcardList.vue?vue&type=template&id=138bdefe&scoped=true&"
import script from "./SimcardList.vue?vue&type=script&lang=js&"
export * from "./SimcardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138bdefe",
  null
  
)

export default component.exports